<template>
  <div class="deposit-table" :aria-busy="loading">
    <div v-if="loading" class="empty-state" role="status"><div class="loader"></div><strong>{{ t('data.loading') }}</strong></div>
    <div v-else-if="error" class="empty-state" role="alert"><strong>{{ typeof error === 'string' ? error : t('error.apiUnavailable') }}</strong><button @click="$emit('page', page)"><RefreshCw/> {{ t('data.retry') }}</button></div>
    <div v-else-if="!rows.length" class="empty-state"><strong>{{ emptyText }}</strong></div>
    <table v-else>
      <thead><tr><th v-if="ranked" class="rank-column" scope="col">{{ t('data.rank') }}</th><th scope="col">{{ t('data.address') }}</th><th class="amount-column" scope="col">{{ t('data.amount') }}</th></tr></thead>
      <tbody><tr v-for="row in rows" :key="row.address">
        <td v-if="ranked" class="rank-column">{{ row.rank }}</td>
        <td><div class="address-cell"><a :href="`${explorerUrl}/address/${row.address}`" :title="row.address" :aria-label="row.address" target="_blank" rel="noopener">{{ shortAddress(row.address) }}</a><button type="button" :title="t('wallet.copy')" :aria-label="`${t('wallet.copy')} ${row.address}`" @click="$emit('copy', row.address)"><Copy/></button></div></td>
        <td class="amount-column">{{ formatAmount(row.performance) }} <small>BNB</small></td>
      </tr></tbody>
    </table>
    <div v-if="total > pageSize && !error" class="table-pagination">
      <button type="button" :disabled="loading || page <= 1" :title="t('data.previous')" :aria-label="t('data.previous')" @click="$emit('page', page - 1)"><ChevronLeft/></button>
      <span>{{ page }} / {{ Math.ceil(total / pageSize) }}</span>
      <button type="button" :disabled="loading || page * pageSize >= total" :title="t('data.next')" :aria-label="t('data.next')" @click="$emit('page', page + 1)"><ChevronRight/></button>
    </div>
  </div>
</template>

<script>
import { Copy, ChevronLeft, ChevronRight, RefreshCw } from 'lucide-vue-next'
import { t } from '../i18n'

export default {
  components: { Copy, ChevronLeft, ChevronRight, RefreshCw },
  props: {
    rows: { type: Array, required: true },
    ranked: Boolean,
    loading: Boolean,
    error: { type: [Boolean, String], default: false },
    total: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    emptyText: { type: String, required: true },
    explorerUrl: { type: String, default: 'https://bscscan.com' },
  },
  emits: ['page', 'copy'],
  methods: {
    t,
    shortAddress(address) { return `${address.slice(0, 6)}…${address.slice(-4)}` },
    formatAmount(value) { return Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: 4 }) },
  },
}
</script>

<style scoped>
.deposit-table{min-width:0;letter-spacing:0}
table{width:100%;border-collapse:collapse;table-layout:fixed;font-size:12px}
th{padding:12px 0;text-align:left;font-weight:400;color:var(--muted);border-bottom:1px solid var(--line)}
td{height:58px;border-bottom:1px solid var(--line)}
.rank-column{width:38px;color:var(--muted)}
.amount-column{width:100px;text-align:right;font-variant-numeric:tabular-nums}
td.amount-column{color:var(--gold)}
.amount-column small{font-size:10px}
.address-cell{display:flex;align-items:center;min-width:0}
.address-cell a{font-family:monospace;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.address-cell button,.table-pagination button{display:grid;place-items:center;width:36px;height:44px;padding:0;flex:none;background:none;border:0;color:var(--muted)}
.address-cell button:hover,.table-pagination button:hover{color:var(--gold)}
.table-pagination{display:flex;align-items:center;justify-content:flex-end;gap:12px;margin-top:12px;font-size:12px;color:var(--muted)}
.empty-state button{display:flex;align-items:center;gap:8px}
</style>
